import { useState } from "react"
import { Modal, Form, InputGroup, FormControl, Button } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import { useRecoilState } from "recoil"
import { useApi } from "../../../../api"
import { ErrorDialog } from "../../../../components/ErrorDialog"
import { ErrorResponseDialog } from "../../../../components/ErrorResponseDialog"
import { SuccessDialog } from "../../../../components/SuccessDialog"
import { ICargo, INftAsset, IProfile } from "../../../../interfaces"
import { nftMyAssetReturnModalAtom } from "../../../../stores/main"
import { Utils } from "../../../../utils"

interface NftMyAssetReturnModalProps {
  selectedAsset: INftAsset | null,
  onClose?: () => void
}
export const NftMyAssetReturnModal = ({selectedAsset, onClose}: NftMyAssetReturnModalProps) => {
  const projectCode = 'NFT'
  const [otp, setOtp] = useState<string | null>(null);
  const [isLoading, setLoading] = useState<boolean>(false)
  const [showModel, setShowModel] = useRecoilState(nftMyAssetReturnModalAtom)

  const api = useApi(projectCode)
  const { t } = useTranslation()

  const handleClose = () => {
    setShowModel(false);
    if (onClose) {
      onClose();
    }
  }
  
  return (
    <>
      <Modal show={showModel} onHide={handleClose} aria-labelledby="contained-modal-title-vcenter" centered>
        <Modal.Header closeButton>
          <div style={{width:'24px'}}></div>
          <Modal.Title>{t('giftNft')} {selectedAsset != null && selectedAsset['name']}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {
            selectedAsset?.creatorProfile && <div className="w-20 m-3">
              <img className="rounded-full" src={Utils().normalizeImagePath(selectedAsset?.creatorProfile.avator, projectCode)} alt={selectedAsset?.creatorProfile.nickname} />
            </div>
          }
          <Form.Group className="mt-3">
            <Form.Label>{t('oneTimePasscode')}</Form.Label>
            <InputGroup>
              <FormControl
                type="password"
                onChange={(e) => {
                  setOtp(e.target.value)
                }}
                aria-label={t('pleaseInputOtp')}
              />
              <Button variant="outline-danger" disabled={isLoading} onClick={() => {
                setLoading(true)
                api.sendOtp((cargo: ICargo) => {
                  setLoading(false)
                  if (cargo.returnCode === '000000') {
                    SuccessDialog({ title: t('otpSentSuccess') })
                  } else {
                    switch (cargo.returnCode) {
                      case '100003':
                        ErrorDialog({ title: t(`errorCode.${cargo.returnCode}`) })
                        window.location.href = '/web/login/nft'
                        break;
                      default:
                        ErrorDialog({ title: t('otpSentFailure') })
                    }
                  }
                })
              }}>{t('sendOtp')}</Button>
            </InputGroup>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button disabled={isLoading} onClick={() => {
            if (otp === null) {
              ErrorDialog({ title: t('pleaseInputOtp') })
              return
            }
            if (selectedAsset) {
              setLoading(true)
              api.returnNft(selectedAsset.nftId, (cargo: ICargo) => {
                setLoading(false)
                if (cargo.returnCode === '000000'){
                  handleClose()
                  SuccessDialog({ title: '完成' })
                } else {
                  ErrorResponseDialog(cargo, t);
                }
              })
            }
          }}>返還創作者/支付</Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}